module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (33).ee49e36c.jpg";